// extracted by mini-css-extract-plugin
export default {"container":"Xi-z","blurb":"Yi-z","links":"Zi-z"};